import { render, staticRenderFns } from "./ReachabilityBurningMatter.vue?vue&type=template&id=286c2636&"
import script from "./ReachabilityBurningMatter.vue?vue&type=script&lang=js&"
export * from "./ReachabilityBurningMatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports